import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { sqlSourceAdapts } from './sql.copysource.adapter';
import { SqlServerCopySourceAdapter } from 'app/model/adapters/activities/copysource/sql-server.copysource.adapter';
import { AmazonRdsSqlServerCopySource } from 'app/model/pipeline/copysource/amazon-rds-sql-server.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonRdsSqlServerCopySource),
    asynchronous: true,
    adapts: sqlSourceAdapts
})
export class AmazonRdsSqlServerCopySourceAdapter extends SqlServerCopySourceAdapter {}
